export const getOrderStatus = (accountNo: string, crNo: string, msisdn: string) => {
	return {
		url: `order-tracking/ordertracking?accountNo=${accountNo}&crNo=${crNo}&msisdn=${msisdn}`,
	};
};
